<template>
  <div class="recover-acc" v-loading.fullscreen.lock="loading">
    <div class="sec">
      <top :title="'活动详情'"></top>
      <!-- <price-table :type="2"></price-table> -->
      <div class="con spcial" v-html="act_info.recover_info"></div>
    </div>

    <price-form ref="form" :recover_description="config_info.recover_description" :title="'系统账号回收'" :type="2" @submit="submitData" :wechatShow="act_info.display_weixin_recover" :wechat="act_info.service_recover" :qqShow="act_info.display_qq_recover" :sale_extend="act_info.sale_extend*1||0" :qq="act_info.qq_recover"></price-form>

    <div class="sec">
      <top :title="'活动细则'"></top>
      <div class="con" v-html="act_info.recover_rule"></div>
    </div>
  </div>
</template>

<script>
import top from '@/components/common/top/top'
import priceTable from '@/components/common/pricetable/priceTable'
import priceForm from '@/components/common/priceform/priceForm'
import { configResource, recoverResource } from '@/resource/resource'
import {mapState} from 'vuex'
const ERR_OK = 0

export default {
  name: 'recoverAcc',
  data () {
    return {
      act_info: {
        service_recover: ''
      },
      loading: false
    }
  },
  computed: {
    ...mapState(['config_info'])
  },
  created () {
    if (!this.config_info.reInfo) {
       this.getRule()
    } else {
      this.act_info = this.config_info.reInfo
    }
  },
  methods: {
    getRule() {
      this.loading = true
      configResource.config({ config: 'recover_rule,recover_info,recover_form_extend,qq_recover,display_qq_recover,display_weixin_recover,service_recover,sale_extend' }).then(response => {
        response = response.body
        this.loading = false
        if (response.errcode === ERR_OK) {
          this.config_info.reInfo = response.data
          this.act_info = response.data
        }
      })
    },
    submitData(data) {
      this.loading = true
      recoverResource.recover(data).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.$alert(res.data, '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$refs.form.clearForm()
            }
          })
        }
      })
    }
  },
  components: {
    top,
    priceTable,
    priceForm
  }
}
</script>

<style lang="stylus" scoped>
.recover-acc
  width 1000px
  margin 0 auto
  .sec
    .con
      padding 25px 40px
      color #626262
      font-size 14px
      border 1px solid #dcdcdc
      line-height 22px
</style>



// WEBPACK FOOTER //
// recoverAcc.vue?8a463d9e